import { Link } from "react-router-dom";
import { Seo } from "@/components/common/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { legal } from "@/data/legal";
import { visibleApps } from "@/data/apps";

export default function Legal({ kind }) {
  const doc = legal[kind];

  return (
    <>
      <Seo
        title={doc.title}
        path={`/${kind === "privacy" ? "privacy" : "terms"}`}
        description={`${doc.title} for tutinsapp studio apps and website.`}
      />
      <PageHeader label={`Updated ${doc.updated}`} lines={[doc.title]} intro={doc.intro} />

      <section className="pb-24 sm:pb-32">
        <div className="shell grid gap-14 lg:grid-cols-[240px_1fr] lg:gap-16">
          <aside className="lg:sticky lg:top-28 lg:self-start" aria-label="On this page">
            <p className="label mb-4">Contents</p>
            <ol className="space-y-2">
              {doc.sections.map((s, i) => (
                <li key={s.title}>
                  <a
                    href={`#sec-${i}`}
                    data-testid={`legal-toc-${kind}-${i}`}
                    className="link-underline text-xs text-gray-500 transition-colors duration-300 hover:text-white"
                  >
                    {String(i + 1).padStart(2, "0")}. {s.title}
                  </a>
                </li>
              ))}
            </ol>
            <div className="mt-8 space-y-2 pt-6" style={{ borderTop: "1px solid var(--line)" }}>
              <p className="label mb-3">Applies to</p>
              {visibleApps.map((a) => (
                <Link
                  key={a.id}
                  to={`/apps/${a.slug}`}
                  data-testid={`legal-applies-${a.slug}`}
                  className="link-underline block text-xs text-gray-400 hover:text-white"
                >
                  {a.name}
                </Link>
              ))}
            </div>
          </aside>

          <article data-testid={`legal-body-${kind}`}>
            <p
              className="rounded-2xl p-5 text-sm leading-relaxed text-gray-400"
              style={{ background: "var(--surface)", border: "1px solid var(--line)" }}
            >
              {doc.appNote}
            </p>

            {doc.sections.map((s, i) => (
              <Reveal key={s.title} delay={0.03 * i}>
                <section id={`sec-${i}`} className="scroll-mt-28 pt-12">
                  <h2 className="font-display flex items-baseline gap-4 text-xl font-bold tracking-tight text-white sm:text-2xl">
                    <span className="font-mono-x text-xs text-gray-600">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {s.title}
                  </h2>
                  <div className="mt-4 space-y-4">
                    {s.body.map((p, j) => (
                      <p key={j} className="text-sm leading-relaxed text-gray-400 sm:text-base">
                        {p}
                      </p>
                    ))}
                  </div>
                </section>
              </Reveal>
            ))}

            <p className="mt-16 text-xs leading-relaxed text-gray-600">
              This document is a starting template written in plain language. Text in square
              brackets must be completed, and we recommend a qualified adviser reviews it before
              publication.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}
